
import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useMutation as useConvexMutation } from "convex/react";
import { api } from "../../api";
import { toast } from "sonner";

interface DeleteLevelDialogProps {
  levelId: string;
  levelName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDeleted: () => void;
}

export const DeleteLevelDialog = ({ 
  levelId, 
  levelName, 
  open, 
  onOpenChange, 
  onDeleted 
}: DeleteLevelDialogProps) => {
  const deleteLevelMutation = useConvexMutation(api.levels.delete.level);

  const handleDelete = async () => {
    try {
      console.log(`[DeleteLevel] Starting deletion for level: ${levelId}`);
      
      await deleteLevelMutation({ level: levelId as any });
      
      console.log(`[DeleteLevel] Successfully deleted level: ${levelId}`);
      
      toast.success(`"${levelName}" has been permanently deleted.`);
      onDeleted();
      onOpenChange(false);
    } catch (error) {
      console.error('Error deleting level:', error);
      toast.error("Failed to delete level. Please try again.");
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Trash2 className="w-5 h-5 text-red-500" />
            Delete Level
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{levelName}"? This action cannot be undone.
            <br /><br />
            This will permanently delete the level and all its associated:
            <div className="list-disc list-inside mt-2 space-y-1">
              <div>• App rules (whitelist/blacklist)</div>
              <div>• Device restrictions</div>
              <div>• Network rules</div>
              <div>• Level configuration</div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-red-600 hover:bg-red-700"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Delete Level
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
